import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@sparefoot/react-core';
import { overwriteDisplayName } from '@sparefoot/react-core/tracking-lib';
import useLazyLoad from 'hooks/useLazyLoad';

const LazyImage = (props) => {
	const { src: originalSrc, lazyLoad, ...rest } = props;
	const { displaySrc, getRef } = useLazyLoad(originalSrc, lazyLoad);

	return (
		<Image
			{...rest}
			src={displaySrc}
			getRef={getRef}
		/>
	);
};

LazyImage.propTypes = {
	src: PropTypes.string,
	lazyLoad: PropTypes.bool,
};

export const enhance = () => {
	const EnhancedImage = (props) => {
		if (!props.lazyLoad) {
			return <Image {...props} />;
		}
		return <LazyImage {...props} />;
	};
	EnhancedImage.propTypes = {
		src: PropTypes.string,
		lazyLoad: PropTypes.bool,
	};
	return overwriteDisplayName('Image')(EnhancedImage);
};

export default enhance();
